<template>
  <div>
    <EditCreditLimit
      :creditLimit="creditLimit"
      :clientId="clientId"
      :companyID="companyId"
    ></EditCreditLimit>
    <WalletTopUp :clientId="clientId" :companyID="companyId"></WalletTopUp>

    <MasterLayout>
      <!-- LOADER -->
      <section class="row card-loader-wrapper w-100" v-if="allLoader">
        <div
          class="col-md-6 position-relative mb-2"
          v-for="(c, i) in 2"
          :key="i"
        >
          <div class="card-loader"></div>
        </div>
        <!-- LOADER -->
        <div
          class="showLoaderDiv charts__loader w-full mt-5 rounded-lg w-full"
          style="width: 130% !important; height: 100%"
          v-if="showLoader"
        >
          <div :class="showLoader ? 'loading' : null"></div>
        </div>
        <!-- END LOADER -->
      </section>
      <!-- END LOADER -->

      <section v-if="!allLoader && clientData">
        <section>
          <div class="fuelbalance_first_row">
            <div class="row align-items-center mx-auto" style="width: 97%">
              <div class="col-sm-12 col-lg-4 py-4 px-4 wallet-card shadow-sm">
                <div>
                  <h4>Wallet Balance</h4>
                  <h3>{{ convertThousand(clientData.balance) }}</h3>
                </div>

                <section class="flow d-flex mb-1" v-if="walletInfo">
                  <div class="py-1 pl-2">
                    <span>{{ $t("text.assets.inflow") }}:</span>
                    <span style="font-weight: 600" class="">{{
                      convertThousand(walletInfo.inflow)
                    }}</span>
                  </div>

                  <div class="py-1 ml-4">
                    <span>{{ $t("text.assets.outflow") }}:</span>
                    <span style="font-weight: 600" class="">{{
                      convertThousand(walletInfo.outflow)
                    }}</span>
                  </div>
                </section>

                <section class="d-flex">
                  <div class="credit-limit py-1 pl-2">
                    <span>Credit limit:</span>
                    <span style="font-weight: 600" class="">{{
                      convertThousand(clientData.creditLimit)
                    }}</span>
                  </div>
                </section>
              </div>

              <div class="col-sm-12 col-lg-8">
                <div
                  style="background-color: #f3f4f5; color: #8991a0"
                  class="mt-3 d-flex overview-card py-3 px-4 shadow-sm"
                >
                  <div>
                    <img
                      :src="clientData.logoUrl"
                      style="width: 90px; border-radius: 100%"
                      class="mr-4"
                      v-if="clientData.logoUrl"
                    />

                    <img
                      src="@/assets/img/avatar.svg"
                      style="width: 90px; border-radius: 100%"
                      class="mr-4"
                      v-if="!clientData.logoUrl"
                    />
                  </div>
                  <div class="">
                    <h3 class="text-dark">
                      {{ clientData.name }}
                      <span style="font-size: 20px"
                        >({{ clientData.username }})</span
                      >
                    </h3>
                    <p>{{ clientData.email }}</p>
                    <div class="d-flex align-items-center">
                      <div class="mr-3 d-flex align-items-center">
                        <img
                          src="@/assets/svg/tel.svg"
                          width="15"
                          style="margin-top: -20px"
                          class="mr-2"
                        />
                        <p class="">{{ clientData.phoneNumber }}</p>
                      </div>

                      <div class="d-flex align-items-center">
                        <img
                          src="@/assets/svg/location.svg"
                          width="15"
                          style="margin-top: -20px"
                          class="mr-2"
                        />
                        <p class="">
                          {{
                            `${clientData.address} ${clientData.state} ${clientData.country}`
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- tabs -->

        <section
          class="d-flex flex-column-reverse flex-lg-row justify-content-between my-2"
        >
          <section>
            <div class="d-flex ml-4 mt-3 tabs">
              <div
                @click="() => (this.tab = 'walletHistory')"
                class="tab mr-3"
                :class="tab === 'walletHistory' && 'activeTab'"
              >
                {{ $t("text.retainership.walletHistory") }}
              </div>

              <div
                @click="() => (this.tab = 'voucher')"
                class="tab mr-3"
                :class="tab === 'voucher' && 'activeTab'"
              >
                {{ $t("text.cusMasterLayout.voucher") }}
              </div>

              <div
                @click="() => (this.tab = 'cards')"
                class="mr-4 tab"
                :class="tab === 'cards' && 'activeTab'"
              >
                {{ $t("text.cards.cards") }}
              </div>

              <div
                @click="() => (this.tab = 'pendingRequests')"
                class="tab"
                :class="tab === 'pendingRequests' && 'activeTab'"
              >
                {{ $t("text.retainership.pendingRequest") }}
              </div>
            </div>
          </section>

          <!-- modal actions -->
          <section class="d-flex mr-4 my-1">
            <div
              class="mr-2"
              v-if="tab === 'walletHistory' || tab === 'voucher'"
            >
              <vue-ctk-date-time-picker
                v-model="dateRange"
                :max-date="maxDate"
                :range="true"
                :autoClose="true"
                :locale="this.$root.$i18n.locale"
                :custom-shortcuts="customShortcuts"
                color="#4b2d73"
                format="DDMMYYYY"
                formatted="DD/MM/YYYY"
                :label="$t('text.calendar.dateRange')"
              />
            </div>
            <button
              class="py-2 px-3 text-white"
              style="
                background-color: #46266e;
                border: none;
                border-radius: 5px;
                font-size: 14px;
              "
              @click="openCreditLimitModal"
            >
              {{ $t("text.assets.updateCreditLimit") }}
              <!-- <img
                src="@/assets/img/paper-plane.png"
                width="25px"
                class="ml-3"
              /> -->
            </button>

            <button
              class="ml-2 py-2 px-3 text-white"
              style="
                background-color: #46266e;
                border: none;
                border-radius: 5px;
                font-size: 14px;
              "
              @click="openWalletTopUpModal"
            >
              {{ $t("text.retainership.walletTopup") }}
            </button>
          </section>
          <!--  -->
        </section>

        <!--  -->

        <section class="section__row mt-3">
          <div class="">
            <div class="position-relative" v-if="!showLoader">
              <VoucherHistory
                v-if="tab === 'voucher'"
                :voucherHistory="voucherHistory"
              />
              <CardList :cards="cardList" v-if="tab === 'cards'" />
              <WalletHistory
                :walletHistory="walletHistory"
                v-if="tab === 'walletHistory'"
              />
              <PendingClientRequest
                :pendingRequest="pendingRequest"
                v-if="tab === 'pendingRequests'"
              />
            </div>
            <TableLoader :showLoader="showLoader" v-else />
            <DropDown :details="details" />
          </div>
        </section>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/BecomeDealer.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";

//components
import PendingClientRequest from "../../../BreakdownComponent/Company/Remis/RetainerDetails/PendingClientRequest.vue";
import WalletHistory from "../../../BreakdownComponent/Company/Remis/RetainerDetails/WalletHistory.vue";
import VoucherHistory from "../../../BreakdownComponent/Company/Remis/RetainerDetails/VoucherHistory.vue";
import CardList from "../../../BreakdownComponent/Company/Remis/RetainerDetails/CardList.vue";
import WalletTopUp from "@/components/modals/Retainership/walletTopUp";
import RetTemp from "@/components/Templates/companyRetainershipTemplate.vue";
import EditCreditLimit from "@/components/modals/Retainership/editCreditLimit";
import DropDown from "@/components/Templates/Dropdown/companyRetainershipDropdown.vue";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Retainership :: Epump Portal",
  name: "Retainership",
  components: {
    MasterLayout,
    CardList,
    WalletHistory,
    VoucherHistory,
    PendingClientRequest,
    TableLoader,
    DropDown,
    WalletTopUp,
    EditCreditLimit,
  },

  data() {
    return {
      walletInfo: null,
      allLoader: false,
      cardList: [],
      walletHistory: [],
      voucherHistory: [],
      pendingRequest: [],
      tab: "walletHistory",
      ID: this.$route.query.ID,
      clientId: this.$route.query.clientId,
      clientData: null,

      cardCharge: 0,
      totalCards: 0,
      issuedCards: 0,
      unissuedCards: 0,
      cards: [
        {
          title: this.$t("text.retainership.totalCards"),
        },

        {
          title: this.$t("text.retainership.issuedCard"),
        },

        {
          title: this.$t("text.retainership.unissuedCard"),
        },
      ],

      usedLang: this.$store.getters.getLanguage,
      corpId: null,
      backgroundUrl,
      cardBackgroundUrl,
      fuelBalance: 0,
      walletTransactions: null,
      showLoader: false,
      totalTransactions: null,
      tableDataCount: 10,
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,

      retainerships: null,
      retainershipCount: 0,
      creditLimit: "",
      email: "",
      company: null,
      companyId: this.$route.query.companyId
        ? this.$route.query.companyId
        : this.company
        ? this.company.id
        : "",
      details: {
        data: { status: "" },
        queryStrings: { id: "", companyId: this.$route.query.companyId },
        info: [
          {
            name: this.$t("text.retainership.walletTopup"),
            emitName: "walletTopup",
          },
          {
            name: this.$t("text.assets.walletTransactions"),
            emitName: "walletTransactions",
          },
          {
            name: this.$t("text.assets.updateCreditLimit"),
            emitName: "updateCreditLimit",
          },
        ],
        delete: {
          hasDelete: false,
          deleteName: "deleteInvoice",
          name: "Delete",
          query: "id",
        },
      },
      optionsTemplate: function () {
        return {
          template: RetTemp,
        };
      },
      // dateRange

      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      startDate: this.$moment().subtract(90, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(30, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      //
    };
  },
  watch: {
    tab(newVal) {
      if (newVal) {
        if (newVal === "walletHistory") {
          this.getWalletHistory();
        }
        if (newVal === "pendingRequests") {
          this.getCardRequests();
        }
        if (newVal === "cards") {
          this.getCards();
        }
        if (newVal === "voucher") {
          this.getVoucherHistory();
        }
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );

        if (this.tab === "voucher") {
          this.getVoucherHistory();
        }

        if (this.tab === "walletHistory") {
          this.getWalletHistory();
        }
      }
    },
    company(company) {
      if (company !== null) {
        this.companyId = this.$route.query.companyId
          ? this.$route.query.companyId
          : company.id;

        const remisHash = JSON.parse(localStorage.getItem("rHash"));

        if (!remisHash) {
          this.getRemisHash();
        } else {
          this.callEndpoints();
        }
      }
    },
  },
  created() {
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });

    if (this.$route.query.companyId) {
      const remisHash = JSON.parse(localStorage.getItem("rHash"));
      if (!remisHash) {
        this.getRemisHash();
      } else {
        this.callEndpoints();
      }
    }

    this.$eventHub.$on("companyRetainershipData", (data) => {
      this.details.data = data;
      this.details.queryStrings.id = data.id;
      this.details.queryStrings.walletId = data.walletId;
      this.details.queryStrings.name = data.firstName;

      const option = document.getElementById("myDropdown");
      option.classList.add("show");

      let index;

      if (data.index > 10 && parseInt(data.index.toString().slice(1)) === 0) {
        index = 10;
      }
      if (data.index > 10 && parseInt(data.index.toString().slice(1)) > 0) {
        index = parseInt(data.index.toString().slice(1));
      }

      if (data.index <= 10) {
        index = data.index;
      }

      option.style.top = `${(80 * index + (85 - index * 2)).toString()}px`;
    });

    this.$eventHub.$on(this.details.info[0].emitName, (queryStrings) => {
      this.walletTopup(queryStrings);
    });

    this.$eventHub.$on(this.details.info[1].emitName, (queryStrings) => {
      this._walletTransactions(queryStrings);
    });

    this.$eventHub.$on(this.details.info[2].emitName, (queryStrings) => {
      this.updateCreditLimit();
    });

    this.$eventHub.$on("getRetainerships", () => {
      this.callEndpoints();
    });
    this.$eventHub.$on("changeRetainership", (route, id, walletId, name) => {
      this.changeRoute(route, id, walletId, name);
    });
    this.$eventHub.$on("setCreditLimit", (creditLimit, email) => {
      this.creditLimit = creditLimit;
      this.email = email;
    });
  },
  beforeDestroy() {
    // this.$eventHub.$off("getRetainerships");
    this.$eventHub.$off("changeRetainership");
    this.$eventHub.$off("setCreditLimit");
  },

  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    //utilities
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },

    revertNumber(number) {
      return Number(number.replace(/[^0-9.]+/g, ""));
    },

    //modals

    openCreditLimitModal() {
      this.$modal.show("editCreditLimit");
    },

    openWalletTopUpModal() {
      this.$modal.show("walletTopup");
    },

    //requests

    callEndpoints() {
      this.getRetainerships();
      if (this.clientId) {
        this.getCards();
        this.getWalletHistory();
        this.getCardRequests();
        this.getVoucherHistory();
      }

      this.getCardCharge();
    },

    //get voucher
    getVoucherHistory() {
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.remisBaseUrl}/D/Vouchers/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }/${this.clientId}?startDate=${this.startDate}&endDate=${
            this.endDate
          }&PageLimit=${10000}&range=5
          `,
          configObject.authConfig({ isRemis: true })
        )
        .then((response) => {
          let index = 0;

          response.data.data.vouchers.forEach((el) => {
            index++;
            el.index = index;

            el.date = this.$moment(el.dateGenerated).format(
              "YYYY-MM-DD hh:mma"
            );
            el.expiryDate = this.$moment(el.expiryDate).format(
              "YYYY-MM-DD hh:mma"
            );
            el.isUsed = el.isUsed ? "Yes" : "No";
            el.transferred = el.transferred ? "Yes" : "No";
            el.location = el.location ? el.location : "N/A";
            el.ownerEmail = el.ownerEmail ? el.ownerEmail : "N/A";
            el.staff = el.staff ? el.staff : "N/A";
            el.vehicle = el.vehicle ? el.vehicle : "N/A";
          });
          this.voucherHistory = response.data.data.vouchers;

          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;

          let customError;
          if (error.response) {
            customError = error.response.data.message;
          } else {
            customError = error.message;
          }

          this.$toast.open({
            message: customError,
            type: "error",
            duration: 5000,
          });
        });
    },

    getCardRequests() {
      if (localStorage.getItem("companyDetails") !== null) {
        companyID = JSON.parse(localStorage.getItem("companyDetails")).id;
      }
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.remisBaseUrl}/D/Retainership/Customer/CardRequests/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?PageLimit=${10000}`,

          configObject.authConfig({ isRemis: true })
        )
        .then((response) => {
          const requests = response.data.data.data;
          requests.forEach((request) => {
            request.orderDate = this.$moment(request.orderDate).format(
              "YYYY/MM/DD"
            );
          });
          this.showLoader = false;

          let pendingRequest = requests.filter(
            (el) => el.orderStatus.toLowerCase() === "pending"
          );

          if (pendingRequest.length > 0 && this.clientData) {
            this.pendingRequest = pendingRequest.filter(
              (el) =>
                el.orderBy.toLowerCase() === this.clientData.name.toLowerCase()
            );
          } else {
            this.pendingRequest = [];
          }
        })
        .catch((error) => {
          this.showLoader = false;

          console.log(error);
        });
    },

    //get wallet history
    getWalletHistory() {
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.remisBaseUrl}/d/WalletTransactions/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }/${this.clientId}?startDate=${this.startDate}&endDate=${
            this.endDate
          }&PageLimit=${10000}&range=5
          `,
          configObject.authConfig({ isRemis: true })
        )
        .then((response) => {
          let index = 0;

          response.data.data.transactions.forEach((el) => {
            index++;
            el.index = index;

            el.date = this.$moment(el.date).format("YYYY-MM-DD hh:mma");

            el.assignedTo = el.assignedTo;
            el.locked = "No";
            el.nameOnCard = el.nameOnCard ? el.nameOnCard : "N/A";
            el.activated = el.activated;
          });
          this.walletInfo = response.data.data;
          this.walletHistory = response.data.data.transactions;

          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;

          let customError;
          if (error.response) {
            customError = error.response.data.message;
          } else {
            customError = error.message;
          }

          this.$toast.open({
            message: customError,
            type: "error",
            duration: 5000,
          });
        });
    },

    getRemisHash() {
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.apiBaseUrl}/Account/RemisHash`,
          configObject.authConfig()
        )
        .then((response) => {
          localStorage.setItem("rHash", JSON.stringify(response.data));

          this.getRetainerships();
        })
        .catch((error) => {});
    },

    getCardCharge() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.remisBaseUrl}/D/Retainership/Customer/CardCharge/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig({ isRemis: true })
        )
        .then((response) => {
          this.showLoader = false;

          this.cardCharge = response.data.data;
        })
        .catch((error) => {
          this.showLoader = false;
          let customError;
          if (error.response) {
            customError = error.response.data.message;
          } else {
            customError = error.message;
          }

          console.log(error);
          this.$toast.open({
            message: customError,
            type: "error",
            duration: 5000,
          });
        });
    },

    //get number of cards
    getCards() {
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.remisBaseUrl}/D/Retainership/Customer/clientCards/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }/${this.clientId}?PageLimit=${10000}`,
          configObject.authConfig({ isRemis: true })
        )
        .then((response) => {
          let index = 0;

          const cards = response.data.data.data;

          cards.forEach((el) => {
            index++;
            el.index = index;
            el.expiryDate = this.$moment(el.expiryDate).format("YYYY-MM-DD");
            el.assignedTo = el.assignedTo ? el.assignedTo : "N/A";
            el.locked = el.locked ? "Yes" : "No";
            el.nameOnCard = el.nameOnCard ? el.nameOnCard : "N/A";
            el.activated = el.activated ? "Yes" : "No";
          });

          this.cardList = cards;
          // if (this.$refs.dataGrid) {
          //   this.$refs.dataGrid.ej2Instances.setProperties({
          //     dataSource: cards,
          //   });
          //   this.refreshGrid();
          // }

          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;

          let customError;
          if (error.response) {
            customError = error.response.data.message;
          } else {
            customError = error.message;
          }

          this.$toast.open({
            message: customError,
            type: "error",
            duration: 5000,
          });
        });
    },

    // get registered retainership companies
    getRetainerships() {
      this.allLoader = true;
      this.axios
        .get(
          `${configObject.remisBaseUrl}/D/Retainership/Customer/Clients/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?PageLimit=${10000}`,
          configObject.authConfig({ isRemis: true })
        )
        .then((response) => {
          this.allLoader = false;

          let data = response.data.data.data.filter((el) => {
            return el.id === this.ID;
          });

          if (data) {
            this.clientData = data[0];
          }
        })
        .catch((error) => {
          this.allLoader = false;

          let customError;
          if (error.response) {
            customError = error.response.data.message;
          } else {
            customError = error.message;
          }

          console.log(error);
          this.$toast.open({
            message: customError,
            type: "error",
            duration: 5000,
          });
        });
    },

    walletTopup(queryStrings) {
      this.changeRoute(
        "RetainershipWalletTransactions",
        queryStrings.id,
        queryStrings.walletId,
        queryStrings.name
      );
    },
    _walletTransactions(queryStrings) {
      this.changeRoute(
        "RetainershipWalletTransactions",
        queryStrings.id,
        queryStrings.walletId,
        queryStrings.name
      );
    },
    updateCreditLimit() {
      this.$eventHub.$emit(
        "setCreditLimit",
        this.details.data.creditLimit,
        this.details.data.email
      );
      this.$modal.show("editCreditLimit");
    },

    changeRoute($newRoute, id, walletId, name) {
      this.$router.push({
        name: $newRoute,
        query: {
          id: id,
          walletId,
          name,
          companyId: this.$route.query.companyId,
        },
      });
    },
    showFundWalletModal() {
      this.$modal.show("fund-wallet-payweall");
    },
    showAddRetainershipModal() {
      this.$modal.show("addRetainershipModal");
    },
  },
};
</script>

<style scoped>
.flow h4 {
  font-size: 16px !important;
}
.tab {
  color: #4c2e73;
  padding: 0px 6px;
  font-weight: 500;
  cursor: pointer;
}

.activeTab {
  padding-bottom: 6px;
  border-bottom: 3px solid;
}
.overview-card {
  background-color: white;
  border: 1px solid #f3f4f5;
  color: #667085;
  border-radius: 10px;
  margin-bottom: 20px;
}

.overview-card h5 {
  font-size: 13px;
  text-transform: uppercase;
}

.overview-card p {
  font-size: 13px;
}
.wallet-card {
  background-color: #f9f9fa;
  border-radius: 8px;
  /* border: 2px solid #f3f4f5; */
}
.wallet-card h4 {
  color: #2b2b2b;
  font-size: 12px;
  font-weight: 600;
}

.wallet-card h3 {
  color: #2b2b2b;
  font-size: 32px;
  font-weight: 700;
}

.credit-limit {
  border-radius: 20px;
  border: 1px solid #d0d3d9;
  width: 250px;
  font-size: 13px;
}

@media screen and (max-width: 602px) {
  .addNewRetainershipModal .v--modal-box.v--modal {
    margin: 0 auto;
    top: 150px !important;
    width: 90% !important;
    height: 500px !important;
    left: 0 !important;
    overflow: auto;
  }
  .addRetainershipModal .v--modal-box.v--modal {
    margin: 0 auto;
    /* top: 88px !important; */
    width: 90% !important;
    height: 379px !important;
    left: 0 !important;
    overflow: auto;
  }
  button.add_quick_fuel_btn {
    margin-bottom: 62px;
  }
}
</style>
